/** @format */

import axios from 'axios'
import CryptoJS from 'crypto-js'
import { user } from '../state/user'
import { env } from '../state/env'
import client from '../utils/client'
import { Native } from '../core/native'
import { ucooAlert } from '../utils/ucoowebview'

function sign_param(param) {
  param.timestamp = Math.floor(new Date().getTime() / 1000).toString()
  param.nonce = Math.floor(Math.random() * 9000000000 + 1000000000).toString()
  param.access_key = 'aa8396d1c7bc42bc89462a196879f9bd'
  var string_a = Object.keys(param)
    .sort()
    .map(function (key) {
      return [key, param[key]].join('=')
    })
    .join('&')
  var string_sign_temp = [string_a, 'secret_key=dd1ad7ddb8d84801ae182794732003e5'].join('&')
  console.log('string_sign_temp', string_sign_temp)
  var sign = CryptoJS.SHA1(string_sign_temp).toString().toUpperCase()
  console.log('sign', sign)
  param.sign = sign
  return param
}

function baseRequest(method, path, params, successCB) {
  let actualParams = sign_param(params)
  if (!actualParams['app-language']) {
    actualParams['app-language'] = env.language
  }
  let requestConfig = {
    url: path,
    baseURL: env.domain,
  }
  let headers = { 'client-platform': 'web' }
  if (user.access_token) {
    headers['Access-Token'] = user.access_token
  }

  if (actualParams['app-language']) {
    headers['App-Language'] = actualParams['app-language']
  }
  if (env.platform) {
    headers['App-Platform'] = env.platform
  }
  if (env.version) {
    headers['App-Version'] = env.version
  }
  requestConfig.headers = headers
  if (method == 'GET') {
    requestConfig.method = 'get'
    requestConfig.params = actualParams
  } else {
    requestConfig.method = 'post'
    requestConfig.data = JSON.stringify(actualParams)
  }
  axios.request(requestConfig).then(function (response) {
    let actualData = response.data
    // console.log("request:", path, "\n response:", actualData);
    if (actualData.status == 0) {
      successCB(actualData.data)
    } else {
      if (requestConfig.url == '/api/wallet/v1/publicidcharge/order/create') {
        alert(actualData.msg)
      } else {
        ucooAlert(actualData.msg)
      }

      console.error('request failed:', actualData.msg)
    }
  })
}

function request(method, path, params, onSuccess, onFailed) {
  let actualParams = sign_param(params)
  if (!actualParams['app-language']) {
    actualParams['app-language'] = env.language
    console.log('request app-language', env.language)
  }
  let requestConfig = {
    url: path,
    baseURL: env.domain,
  }
  let headers = { 'client-platform': 'web' }

  // const keys = Object.keys(customHeaders)
  // keys.forEach(key => {
  //   headers[key] = customHeaders[key]
  // })

  if (user.access_token) {
    headers['Access-Token'] = user.access_token
  } else {
    if (env.debug) {
      headers['Access-Token'] = '10086'
    }
  }
  if (env.platform) {
    headers['App-Platform'] = env.platform
  }
  if (env.version) {
    headers['App-Version'] = env.version
  }
  requestConfig.headers = headers
  if (method == 'GET') {
    requestConfig.method = 'get'
    requestConfig.params = actualParams
  } else {
    requestConfig.method = 'post'
    requestConfig.data = JSON.stringify(actualParams)
  }
  axios.request(requestConfig).then(function (response) {
    let actualData = response.data
    // console.log("request:", path, "\n response:", actualData);
    if (actualData.status == 0) {
      onSuccess(actualData.data)
    } else {
      onRequestFailed(actualData.status, actualData.msg)
      onFailed(actualData.status, actualData.msg)
    }
  })
}

function onRequestFailed(status, msg) {
  client.callNative(
    Native.API_ERROR,
    {
      code: status,
      msg: msg,
    },
    data => {}
  )
}

function extRequest(method, path, params, onSuccess, onFailed) {
  let actualParams = sign_param(params)
  let requestConfig = {
    url: path,
    baseURL: env.domain,
  }
  let headers = { 'client-platform': 'web' }
  if (user.access_token) {
    headers['Access-Token'] = user.access_token
  } else {
    if (env.debug) {
      headers['Access-Token'] = '10086'
    }
  }
  if (env.platform) {
    headers['App-Platform'] = env.platform
  }
  if (env.version) {
    headers['App-Version'] = env.version
  }
  requestConfig.headers = headers
  if (method == 'GET') {
    requestConfig.method = 'get'
    requestConfig.params = actualParams
  } else {
    requestConfig.method = 'post'
    requestConfig.data = JSON.stringify(actualParams)
  }
  axios.request(requestConfig).then(function (response) {
    let actualData = response.data
    // console.log("request:", path, "\n response:", actualData);
    if (actualData.status == 0) {
      onSuccess(actualData.data)
    } else {
      onRequestFailed(actualData.status, actualData.msg)
      onFailed(actualData.status, actualData.msg, actualData)
    }
  })
}

function requestApi(method, path, params, onSuccess, onFailed) {
  let actualParams = sign_param(params)
  let requestConfig = {
    url: path,
    baseURL: env.domain,
  }
  let headers = { 'client-platform': 'web' }
  if (user.access_token) {
    headers['Access-Token'] = user.access_token
  } else {
    if (env.debug) {
      headers['Access-Token'] = '10086'
    }
  }
  if (env.platform) {
    headers['App-Platform'] = env.platform
  }
  if (env.version) {
    headers['App-Version'] = env.version
  }
  requestConfig.headers = headers
  if (method == 'GET') {
    requestConfig.method = 'get'
    requestConfig.params = actualParams
  } else {
    requestConfig.method = 'post'
    requestConfig.data = JSON.stringify(actualParams)
  }
  axios
    .request(requestConfig)
    .then(function (response) {
      let actualData = response.data
      // console.log("request:", path, "\n response:", actualData);
      if (actualData.status == 0) {
        onSuccess(actualData.data)
      } else {
        if (onFailed) {
          onFailed(actualData.status, actualData.msg)
        }
        onRequestFailed(actualData.status, actualData.msg)
      }
    })
    .catch(err => {
      console.log(err)
      if (onFailed) {
        onFailed(-999, err.message)
      }
    })
}

/**
 * @param method: GET | POST
 * @param path: url
 * @param params: 请求参数
 * @param onFailed: 失败回调
 * 下载文件
 */
function requestFile(method, path, params, onFailed) {
  let actualParams = sign_param(params)
  let requestConfig = {
    url: path,
    baseURL: env.domain,
    responseType: 'blob',
  }
  let headers = { 'client-platform': 'web' }
  if (user.access_token) {
    headers['Access-Token'] = user.access_token
  } else {
    if (env.debug) {
      headers['Access-Token'] = '10086'
    }
  }
  if (env.platform) {
    headers['App-Platform'] = env.platform
  }
  if (env.version) {
    headers['App-Version'] = env.version
  }
  requestConfig.headers = headers
  if (method == 'GET') {
    requestConfig.method = 'get'
    requestConfig.params = actualParams
  } else {
    requestConfig.method = 'post'
    requestConfig.data = JSON.stringify(actualParams)
  }
  axios
    .request(requestConfig)
    .then(function (response) {
      const { data, headers } = response
      // const fileName = headers['content-disposition'].replace(/\w+; filename=(.*)/, '$1');
      const cd = response.headers.get('Content-Disposition')
      let fileName = 'data.xlsx'
      if (cd) fileName = cd.split('filename=')[1]

      const blob = new Blob([data], { type: headers['content-type'] })
      let dom = document.createElement('a')
      let url = window.URL.createObjectURL(blob)
      dom.href = url
      dom.download = decodeURI(fileName)
      dom.style.display = 'none'
      document.body.appendChild(dom)
      dom.click()
      dom.parentNode.removeChild(dom)
      window.URL.revokeObjectURL(url)
    })
    .catch(err => {
      console.log(err)
      if (onFailed) {
        onFailed(-999, err.message)
      }
    })
}

function getApi(path, params, onSuccess, onFailed) {
  requestApi('GET', path, params, onSuccess, onFailed)
}

/**
 * POST 请求
 * @param {api_path} path
 * @param {请求参数} params
 * @param {成功回调} onSuccess [data]
 * @param {失败回调} onFailed 【status,msg】
 */
function postApi(path, params, onSuccess, onFailed) {
  requestApi('POST', path, params, onSuccess, onFailed)
}

async function promiseGetApi(path, params) {
  return new Promise(function (resolve, reject) {
    getApi(path, params, resolve, (code, msg) => reject({ code: code, msg: msg }))
  })
}

async function promisePostApi(path, params) {
  return new Promise(function (resolve, reject) {
    postApi(path, params, resolve, (code, msg) => reject({ code: code, msg: msg }))
  })
}

export { baseRequest, request, extRequest, getApi, postApi, requestFile, promiseGetApi, promisePostApi }
